var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSplit2 = function SvgSplit2(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M15.193 1.8a1.13 1.13 0 0 1 1.227.242l2.25 2.25a1.123 1.123 0 0 1 0 1.589l-2.25 2.25a1.12 1.12 0 0 1-1.227.242 1.125 1.125 0 0 1-.696-1.04V6.214H13.18c-.299 0-.583.12-.794.33L9.34 9.589l3.044 3.044c.21.21.495.33.794.33h1.318V11.84a1.129 1.129 0 0 1 1.923-.798l2.25 2.25a1.123 1.123 0 0 1 0 1.588l-2.25 2.25a1.12 1.12 0 0 1-1.227.242 1.125 1.125 0 0 1-.696-1.04v-1.118H13.18a3.37 3.37 0 0 1-2.386-.988L7.28 10.714H2.125a1.124 1.124 0 1 1 0-2.25H7.28l3.512-3.511a3.37 3.37 0 0 1 2.386-.988h1.318V2.84c0-.453.274-.864.696-1.04"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSplit2);
export default ForwardRef;